<rappider-data-schema-element-row *ngIf="activeProject?.id"
                                  [data]="dataEvent.payload?.fields"
                                  [activeProjectId]="activeProject.id"
                                  addButtonText="PROJECT_MODULE.DATA_EVENT_PAYLOAD_COMPONENT.ADD_DATA_EVENT_PAYLOAD"
                                  [cancelButtonText]="'Reset'"
                                  [dataSchemaPageType]="DataSchemaPageType"
                                  (saveButtonClick)="onDataSchemaSave($event)">
</rappider-data-schema-element-row>